const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://p01--backend--fbt2wjdzbm9v.code.run';

export { API_BASE_URL };
